// extracted by mini-css-extract-plugin
module.exports = {"icon":"idt-icon_icon__3rcjd","small":"idt-icon_small__3btbu","medium":"idt-icon_medium__9mb_a","large":"idt-icon_large__2lcon","xlarge":"idt-icon_xlarge__1sbm-"};